import '@ids/style-tag';
import './Tagline.css';

import type { Icon, TaglineColor, TextSize } from '../../global-types/Content';
import { IdsIcon } from '../icon/Icon';

type TaglineProps = {
  text: string;
  color: TaglineColor | undefined;
  icon?: Icon;
  size?: TextSize | undefined;
};

function Tagline({ text, color, icon, size }: TaglineProps) {
  let taglineType: string;
  let textColor: string = '';

  switch (color) {
    case 'green':
      taglineType = 'green';
      textColor = 'color-green-400 weight-medium';
      break;
    case 'yellow':
      taglineType = 'yellow';
      break;
    case 'red':
      taglineType = 'red';
      break;
    case 'blue':
      taglineType = 'blue';
      break;
    default:
      taglineType = 'background-white border-none';
      break;
  }

  return (
    <div className={`if ${taglineType} tag ${size ? size : ''} `}>
      <div className={`if typography ui small flex gap-8  ${textColor}`}>
        {icon && <IdsIcon name={icon} size={16} />}
        <span className="if pt-2">{text}</span>
      </div>
    </div>
  );
}

export default Tagline;
